import { FlexiblePriceAlert } from "@/components/flexible-price-alert";

export const FlexiblePriceAppointmentDrawerAlert = (): JSX.Element | null => {
  return (
    <FlexiblePriceAlert message="Em caso de cancelamento, este agendamento poderá acarretar em uma cobrança." />
  );
};
